import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import './AdvancedSearch.css'
import { Link } from 'react-router-dom'
import banner from '../../assets/images/Advance Search Banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const AdvancedSearch = () => {
  const { top } = useLocation();
  useEffect(()=>{
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  },[top])
  return (
    <>
    <div className="container-fluid gx-0">
        <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
    </div>

    <div className='container py-lg-5 py-3'>
      <div className="row">
        <p className='top-content' data-aos="zoom-in">Can't find what you're looking for? Use our advanced search features to get more specific information.</p>
      </div>
      <div className="row my-lg-5">
        <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="card p-lg-3 advance-search-card" data-aos="zoom-in">
                <h5>Search by</h5>
                <ul>
                    <li>Product Name</li>
                    <li>Therapeutic Area</li>
                    <li>Formulation</li>
                    <li>Indication</li>
                </ul>
            </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="card p-lg-3 advance-search-card" data-aos="zoom-in">
                <h5>Information Resources</h5>
                <ul>
                    <li>Product Monographs</li>
                    <li>Safety Data Sheets (SDS)</li>
                    <li>Clinical Trial Reports</li>
                    <li>Regulatory Documents</li>
                </ul>
            </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
        <div className="card p-lg-3 advance-search-card" data-aos="zoom-in">
                <h5>Need more information?</h5>
                <ul>
                    <li>Request a Product Catalogue</li>
                    <li>Download Scientific Literature</li>
                    <li>Ask Our Expert (submit a query)</li>
                    
                </ul>
            </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12" data-aos="zoom-in">
            <h3>Or, contact us directly</h3>
            <p><Link to='/contact-us'>contact us</Link></p>
        </div>
        <div className="col-12 mt-lg-5">
            <h3 data-aos="zoom-in">This section allows users to</h3>
            <ol data-aos="zoom-in">
                <li>Refine their search using specific filters.</li>
                <li>Access detailed information resources.</li>
                <li>Request additional information or documentation.</li>
                <li>Connect with our company directly.</li>
                
            </ol>
        </div>
      </div>
    </div>

    </>
  )
}

export default AdvancedSearch
